import React from 'react';
import InputValidation from '../_InputValidation';
import { Slot } from './slots';

var CheckboxOrRadioGroupValidation = function CheckboxOrRadioGroupValidation(_ref) {
  var children = _ref.children,
      variant = _ref.variant,
      sx = _ref.sx;
  return /*#__PURE__*/React.createElement(Slot, {
    name: "Validation"
  }, function (_ref2) {
    var _ref2$validationMessa = _ref2.validationMessageId,
        validationMessageId = _ref2$validationMessa === void 0 ? '' : _ref2$validationMessa;
    return /*#__PURE__*/React.createElement(InputValidation, {
      validationStatus: variant,
      id: validationMessageId,
      sx: sx
    }, children);
  });
};

CheckboxOrRadioGroupValidation.displayName = "CheckboxOrRadioGroupValidation";
export default CheckboxOrRadioGroupValidation;